module.exports = __webpack_public_path__ + "static/media/Tak-min.6f35fece.PNG";